import React, { useState, useEffect } from 'react';
import { addJobRoles, updateJobRoles } from '../services/career';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const CareerJobEdit = ({
  jobRole,
  onClose,
  handleLocalUpdate,
  notifySuccess,
  notifyDanger,
}) => {
  const [formData, setFormData] = useState({
    roleName: '',
    categories: [],
    location: '',
    package: '',
    description: '',
  });

  useEffect(() => {
    if (jobRole) {
      setFormData({
        _id: jobRole?._id || '',
        roleName: jobRole.roleName || '',
        categories: jobRole.categories || [],
        location: jobRole.location || '',
        package: jobRole.package || '',
        description: jobRole.description || '',
      });
    }
  }, [jobRole]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'categories') {
      setFormData({
        ...formData,
        categories: value.split(',').map((cat) => cat.trim()),
      });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData._id) {
      const newData = formData;

      delete newData._id;
      try {
        const response = await addJobRoles(newData);
        if (response.message) {
          notifySuccess(response.message || 'successfully added');
          handleLocalUpdate(formData);
          if (onClose) onClose();
        } else {
          notifyDanger(response.error || 'something went wrong');
        }
      } catch (error) {
        notifyDanger(error.message || 'internal server error');
      }
    } else {
      try {
        const response = await updateJobRoles(formData);
        if (response.message) {
          notifySuccess(response.message || 'successfully updated');
          handleLocalUpdate(formData);
          if (onClose) onClose();
        } else {
          notifyDanger(response.error || 'something went wrong');
        }
      } catch (error) {
        notifyDanger(error.message || 'internal server error');
      }
    }
  };

  return (
    <div className="w-full max-w-3xl mx-auto bg-white rounded-lg shadow-sm border border-gray-200 p-4 sm:p-6">
      <ToastContainer />
      <h2 className="text-lg font-semibold text-gray-800 mb-5 pb-3 border-b border-gray-200">
        {jobRole?._id ? 'Edit Job Role' : 'Add Job Role'}
      </h2>
      <form onSubmit={handleSubmit}>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
          <div>
            <label className="block text-sm font-medium text-gray-600 mb-1">Role Name</label>
            <input
              type="text"
              name="roleName"
              value={formData.roleName}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-600 mb-1">
              Categories (comma-separated)
            </label>
            <input
              type="text"
              name="categories"
              value={formData.categories.join(', ')}
              placeholder="Engineering, Remote, Full-Time"
              onChange={handleChange}
              className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-600 mb-1">Location</label>
            <input
              type="text"
              name="location"
              value={formData.location}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-600 mb-1">Package</label>
            <input
              type="text"
              name="package"
              value={formData.package}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            />
          </div>
        </div>

        <div className="mb-5">
          <label className="block text-sm font-medium text-gray-600 mb-1">Description</label>
          <textarea
            name="description"
            value={formData.description}
            onChange={handleChange}
            rows="4"
            className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 resize-vertical"
          ></textarea>
        </div>

        <div className="flex justify-between items-center pt-4 border-t border-gray-200">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 bg-gray-200 text-gray-700 text-sm font-medium rounded-md hover:bg-gray-300 transition"
          >
            Cancel
          </button>
          <button
            type="submit"
            className="px-5 py-2 bg-blue-600 text-white text-sm font-medium rounded-md hover:bg-blue-700 transition"
          >
            {jobRole?._id ? 'Update' : 'Add'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default CareerJobEdit;

